import { CustomPageHeader, Text } from '@src/components';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import InvoiceFilter from './InvoiceFilter';
import InvoiceList from './InvoiceList';
import PropTypes from 'prop-types';
import { VouIdCode } from '@src/store/enums';

const MyInvoices = ({ isCompliments = false, isMarket = false }) => {
  const dispatch = useDispatch();
  let header;
  let vouId;

  if (isMarket) {
    vouId = VouIdCode.Market;
    header = 'Ticket Market';
  } else if (isCompliments) {
    vouId = VouIdCode.Compliments;
    header = 'Ticket Gift';
  } else {
    vouId = VouIdCode.Restaurant;
    header = 'Ticket Restaurant';
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dispatch]);

  return (
    <CustomPageHeader
      data-testid="manage-my-cards"
      title={<Text t="trackInvoice" />}
      showBreadCrumb
      showHelpButton
      routes={[header]}
    >
      <InvoiceFilter isCompliments={isCompliments} isMarket={isMarket} vouId={vouId} />
      <InvoiceList isCompliments={isCompliments} isMarket={isMarket} vouId={vouId} />
    </CustomPageHeader>
  );
};

MyInvoices.propTypes = {
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
};

export default MyInvoices;
